export type FormValues = {
  first_name: string
  last_name: string
  username: string | null
  birthday: Date | null
  phone: string | null
  country: string | null
  gender: string | null
  email: string | null
  current_password?: string
  new_password?: string
}

export type EditField = {
  key: keyof FormValues | 'password' | 'name'
  title: string
}

export type ProfileFieldKey = keyof FormValues | 'password' | 'name'

export type FieldDisplayNames = {
  [K in ProfileFieldKey]: string
}

export const FIELD_DISPLAY_NAMES: FieldDisplayNames = {
  name: 'Name',
  username: 'Username',
  birthday: 'Date of birth',
  phone: 'Phone',
  gender: 'Gender',
  country: 'Country',
  email: 'Email',
  password: 'Password',
  first_name: 'First name',
  last_name: 'Last name',
  current_password: 'Current password',
  new_password: 'New password',
} as const

/**
 * VRG-607 — the fallback was the literal string 'Field', and callers build copy
 * as `${getFieldDisplayName(key)} updated`. An unmapped key therefore rendered
 * **"Field updated"** to a shopper: placeholder text of the same class as a
 * stray "undefined", and indistinguishable from a bug to anyone reading it.
 *
 * 'Your details' is a real thing a person can be told was updated, so the
 * sentence stays true and readable for any key that is missing from the map.
 * The map is still the fix for a specific field — this only makes the failure
 * mode legible instead of embarrassing.
 */
export const getFieldDisplayName = (key?: string): string => {
  return FIELD_DISPLAY_NAMES[key as ProfileFieldKey] || 'Your details'
}
